import { Store } from '@ngxs/store';
import { ResetEnginePosition, SetEngineChapter, ClearGraph, ResetEngineInteractions } from '../engine/state/engine.actions';
import { SelectBookmarkSuccess } from '../bookmarks/state/bookmarks.actions';
import { ResetStoryChapters } from '../story/state/chapters/story.chapters.actions';
import { ResetLabels } from '../story/state/labels/story.labels.actions';
import { ResetStory } from '../story/state/story.actions';
import { StoryService } from '../story/story.service';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "../story/story.service";
var CleanupService = /** @class */ (function () {
    function CleanupService(store, storyService) {
        this.store = store;
        this.storyService = storyService;
    }
    // Sets the engine and store back to completely unloaded story state
    CleanupService.prototype.resetScene = function () {
        // Hide the engine
        this.store.dispatch(new ResetEnginePosition());
        // Unload scene from engine
        // const story = this.store.selectSnapshot(StoryState.getStory);
        // if (story) {
        //   this.storyService.unloadStory();
        // }
        // Unload current bookmark
        this.store.dispatch(new SelectBookmarkSuccess(null));
        // Remove all chapters
        this.store.dispatch(new ResetStoryChapters());
        this.store.dispatch(new SetEngineChapter(''));
        // Remove all labels
        this.store.dispatch(new ResetLabels());
        // Remove the scene graph
        this.store.dispatch(new ClearGraph());
        // Revert engine prepared state
        // this.store.dispatch(new SetInteractive(false));
        // Reset engine interactions
        this.store.dispatch(new ResetEngineInteractions());
        // Reset story
        this.store.dispatch(new ResetStory());
    };
    CleanupService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CleanupService_Factory() { return new CleanupService(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.StoryService)); }, token: CleanupService, providedIn: "root" });
    return CleanupService;
}());
export { CleanupService };
